<template>
    <div class="fill-height pa-2">
        <v-card class="fill-height d-flex flex-column" style="max-height: 100%; position: relative; " >
            <v-progress-linear v-if="showLoading" absolute indeterminate></v-progress-linear>
            <v-card-title class="pa-0 ma-0 d-flex align-center">
                <div class="dlg-title-bar flex-grow-1">
                    {{ selectedTeam.name }}
                </div>

                <v-tooltip top>
                    <template v-slot:activator="{on}">
                        <v-btn
                                color="indigo"
                                class="mx-1"
                                icon
                                v-on="on"
                                @click="showAddEmployees = true"
                        >
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                    </template>
                    Add Employees
                </v-tooltip>

                <v-tooltip top>
                    <template v-slot:activator="{on}">
                        <v-btn
                                icon
                                color="green"
                                class="mx-1"
                                v-on="on"
                                @click="showRenameTeam = true"
                        >
                            <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                    </template>
                    Rename Team
                </v-tooltip>

                <v-tooltip top>
                    <template v-slot:activator="{on}">
                        <v-btn
                                icon
                                color="red"
                                class="mx-1 mr-3"
                                v-on="on"
                                @click="showConfirmDelete = true"
                        >
                            <v-icon>mdi-delete</v-icon>
                        </v-btn>
                    </template>
                    Delete Team
                </v-tooltip>

            </v-card-title>

            <app-divider label="Working Hours" show-expanded :expanded.sync="showWorkingHours"></app-divider>

            <v-scroll-y-transition hide-on-leave>
                <div v-if="showWorkingHours">
                    <app-working-hours ref="workingHours" :value="selectedTeam.workingHours" @saveWorkingHours="saveWorkingHours"/>
                </div>
            </v-scroll-y-transition>


            <app-divider
                    ref="employeesDivider"
                    label="Employees"
                    :show-search="showEmployees"
                    :search.sync="employeeFilterStr"
            >

<!--                <template v-slot:action>-->
<!--                    <v-tooltip top>-->
<!--                        <template v-slot:activator="{on}">-->
<!--                            <v-btn-->
<!--                                    dark-->
<!--                                    color="primary"-->
<!--                                    icon-->
<!--                                    v-on="on"-->
<!--                                    @click="showAddEmployees = true"-->
<!--                            >-->
<!--                                <v-icon>mdi-plus</v-icon>-->
<!--                            </v-btn>-->
<!--                        </template>-->
<!--                        Add Employees-->
<!--                    </v-tooltip>-->
<!--                </template>-->

            </app-divider>
            <v-scroll-y-transition hide-on-leave>
                <v-list
                        v-if="showEmployees"
                        dense
                        class="mt-0 pt-0 flex-grow-1 of-y"
                        style="padding-bottom: 32px;"
                >
                    <v-list-item
                            @click.self="gotoEmployee(emp._id)"
                            v-for="emp in employeesByTeamSorted"
                            :key="emp._id"
                    >
                        <v-list-item-avatar @click.self="gotoEmployee(emp._id)">
                            <v-icon>mdi-account</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-title v-text="emp.name" @click.self="gotoEmployee(emp._id)"/>
                        <v-list-item-action>
                            <div class="d-flex align-center mr-2">
                                <v-tooltip top>
                                    <template v-slot:activator="{on}">
                                        <v-btn
                                                icon
                                                color="blue"
                                                :loading="loadingEmployees.includes(emp._id)"
                                                :disabled="loadingEmployees.includes(emp._id)"
                                                v-on="on"
                                                @click="transferEmpStart(emp)"
                                                class="mr-2"
                                        >
                                            <v-icon>mdi-swap-horizontal</v-icon>
                                        </v-btn>
                                    </template>
                                    Transfer Employee
                                </v-tooltip>
                                <v-tooltip top>
                                    <template v-slot:activator="{on}">
                                        <v-btn
                                                icon
                                                color="error"
                                                :loading="loadingEmployees.includes(emp._id)"
                                                :disabled="loadingEmployees.includes(emp._id)"
                                                v-on="on"
                                                @click="removeEmployee(emp)"
                                        >
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                    </template>
                                    Remove Employee
                                </v-tooltip>
                            </div>

                        </v-list-item-action>
                    </v-list-item>
                </v-list>
            </v-scroll-y-transition>
        </v-card>
<!--Delete-->
        <v-dialog
                v-if="showConfirmDelete"
                :value="showConfirmDelete"
                :persistent="true"
                width="400"
        >
            <v-card>
                <v-progress-linear
                        v-if="deletingTeam"
                        color="primary"
                        indeterminate
                        absolute
                ></v-progress-linear>

                <v-card-title class="dlg-title-bar">
                    Delete Team
                </v-card-title>

                <v-card-text v-if="!employeesByTeamSorted.length">
                    Please confirm the removal of the team: {{selectedTeam.name}}
                    <br>
                    Please note that this action cannot be undone
                </v-card-text>

                <v-card-text v-else class="overline error--text pb-4 text-center">
                    Error: Team Not Empty
                    <br>
                    Please transfer all employees from "{{selectedTeam.name}}" before proceeding
                </v-card-text>

                <v-divider/>

                <v-card-actions>
                    <v-spacer/>
                    <v-btn
                            class="ml-2"
                            small
                            color="primary"
                            @click="showConfirmDelete = false"
                            outlined
                            size="small"
                            :disabled="deletingTeam"
                    >
                        Cancel
                    </v-btn>

                    <v-btn
                            @click="deleteTeam"
                            small
                            class="ml-2"
                            color="secondary"
                            variant="contained"
                            size="small"
                            :disabled="deletingTeam || !!employeesByTeamSorted.length"
                            :loading="deletingTeam"
                    >
                        Confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
<!--Show Add-->
        <v-dialog
                v-if="showAddEmployees"
                :value="showAddEmployees"
                :persistent="true"
                width="500"
        >
            <v-card>
                <v-progress-linear
                        v-if="addingEmployees"
                        color="primary"
                        indeterminate
                        absolute
                ></v-progress-linear>

                <v-card-title class="dlg-title-bar">
                    Add Employees To {{selectedTeam.name}}
                </v-card-title>

                <v-card-text class="pa-0 ma-0 of-y" style="height: 400px;">
                    <app-list
                            v-model="selectedAddEmployees"
                            :items="availableEmployees"
                            :multiple="true"
                            headline-key="name"
                            item-key="_id"
                            :show-check-boxes="true"
                            :return-object="false"
                            class="fill-height of-y"
                            :height="400"
                    />
                </v-card-text>
                <v-divider/>

                <v-card-actions>
                    <v-spacer/>
                    <v-btn
                            class="ml-2"
                            small
                            color="primary"
                            @click="showAddEmployees = false"
                            outlined
                            size="small"
                            :disabled="addingEmployees"
                    >
                        Cancel
                    </v-btn>

                    <v-btn
                            @click="addEmployeesToTeam"
                            small
                            class="ml-2"
                            color="secondary"
                            variant="contained"
                            size="small"
                            :disabled="addingEmployees || !selectedAddEmployees.length"
                            :loading="addingEmployees"
                    >
                        Add To Team
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
<!--Rename-->
        <app-dlg
                v-if="showRenameTeam"
                :show-dlg.sync="showRenameTeam"
                :model-string.sync="renameTeamName"
                title="Rename Team"
                show-tf
                placeholder="eg. Accounting"
                label="New Team Description"
                class="pa-0 ma-0 mx-2"
                color="primary"
                outlined
                dense
                :rules="[validationRules.required, duplicateTeamName]"
                :disabled="renamingTeam"
                @enter="duplicateTeamName(renameTeamName) === true ? renameTeam() : null"
        >
            <template v-slot:actions>
                <v-btn
                        class="ml-2"
                        small
                        color="primary"
                        @click="showRenameTeam = false"
                        outlined
                        size="small"
                        :disabled="renamingTeam"
                >
                    Cancel
                </v-btn>

                <v-btn
                        @click="renameTeam"
                        small
                        class="ml-2"
                        color="secondary"
                        variant="contained"
                        size="small"
                        :disabled="duplicateTeamName(renameTeamName) !== true || renamingTeam"
                        :loading="renamingTeam"
                >
                    Rename Team
                </v-btn>
            </template>
        </app-dlg>
<!--Transfer-->
        <app-dlg
                ref="transferEmpDlg"
                v-if="showTransferEmp"
                :show-dlg.sync="showTransferEmp"
                :model-string.sync="renameTeamName"
                title="Transfer Employee"
                :default-padding="false"
        >

            <app-list
                    v-model="transferToTeam"
                    :items="teams.filter(team => team !== selectedTeam).sort(nameSort)"
                    :multiple="false"
                    headline-key="name"
                    item-key="_id"
                    :show-check-boxes="true"
                    :return-object="false"
                    class="fill-height of-y"
                    :height="400"
            />

            <template v-slot:actions>
                <v-btn
                        class="ml-2"
                        small
                        color="primary"
                        @click="showTransferEmp = false"
                        outlined
                        size="small"
                >
                    Cancel
                </v-btn>

                <v-btn
                        @click="transferTeam"
                        small
                        class="ml-2"
                        color="secondary"
                        variant="contained"
                        size="small"
                        :disabled="!transferToTeam"
                >
                    Transfer
                </v-btn>
            </template>
        </app-dlg>

    </div>

</template>

<script>
import {Team} from "@/models/team";
import AppDivider from "@/components/Shared/AppDivider/AppDivider";
import {mapActions, mapGetters} from "vuex";
import AppList from "@/components/Shared/AppList/AppList";
import {arrSplice, nameSort, validationRules} from "@/core/codeFunctions";
import AppDlg from "@/components/Shared/AppDlg";
import {Employee} from "@/models/employee";
import AppWorkingHours from "@/components/Shared/AppWorkingHours/AppWorkingHours";

export default {
    components: {AppWorkingHours, AppDlg, AppList, AppDivider},
    props: {
        selectedTeam: {
            required: true,
            type: Team
        },
    },
    data() {
        return {
            showWorkingHours: true,
            showEmployees: true,
            con: console,
            showLoading: false,
            fab: false,
            showAddEmployees: false,
            addingEmployees: false,
            selectedAddEmployees: [],
            showConfirmDelete : false,
            deletingTeam: false,
            employeeFilterStr: null,
            showRenameTeam: false,
            renameTeamName: null,
            renamingTeam: false,
            validationRules: validationRules,
            loadingEmployees: [],
            showTransferEmp: false,
            nameSort: nameSort,
            transferToTeam: null
        }
    },
    watch: {
        showAddEmployees(val) {
            this.addingEmployees = false;
            this.selectedAddEmployees = [];
        },
        showConfirmDelete(val) {
            this.deletingTeam = false;
        },
        showRenameTeam(val) {
            if (val)
                this.renameTeamName = this.selectedTeam.name
        },
        selectedTeam() {
            this.loadingEmployees = []
        }
    },

    methods: {

        ...mapActions(['gotoEmployee']),

        async saveWorkingHours(wh) {
            try {
                this.$refs.workingHours.showLoading = true;
                const team = new Team({...this.selectedTeam, workingHours: wh})
                this.selectedTeam.once('update', () => {
                    this.$refs.workingHours.showLoading = false
                })
                await team.update('workingHours')
            } catch (e) {
                this.$snack.netWorkError()
                this.$refs.workingHours.showLoading = false
            }
        },

        async transferTeam() {
            const emp = this.$refs.transferEmpDlg.refVal
            this.showTransferEmp = false;

            this.loadingEmployees.push(emp._id)
            try {
                const tEmp = new Employee(JSON.parse(JSON.stringify(emp)))
                emp.once('update', () => {
                    arrSplice(this.loadingEmployees, (empId) => emp._id === empId)
                })
                tEmp.teamId = this.transferToTeam;
                await tEmp.update('teamId')

                setTimeout(() => {
                    try {
                        this.$refs.employeesDivider.$refs.filter.focus()
                    } catch (e) {
                        console.log(e)
                    }
                }, 500)
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError();
            }
        },

        transferEmpStart(emp) {
            this.showTransferEmp = true;
            this.$nextTick(() => {
                this.$refs.transferEmpDlg.refVal = emp
            })
        },

        async removeEmployee(emp) {
            this.loadingEmployees.push(emp._id)
            try {
                this.renamingTeam = true;
                const tEmp = new Employee(JSON.parse(JSON.stringify(emp)))
                emp.once('update', () => {
                    arrSplice(this.loadingEmployees, (empId) => emp._id === empId)
                })
                tEmp.teamId = null;
                await tEmp.update('teamId')
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError()
                this.renamingTeam = false
            }
        },

        async renameTeam() {

            if (this.selectedTeam.name === this.renameTeamName)
                this.showRenameTeam = false;

            try {
                this.renamingTeam = true;
                const team = new Team({...this.selectedTeam, name: this.renameTeamName})
                this.selectedTeam.once('update', () => {
                    this.renamingTeam = false
                    this.showRenameTeam = false;
                })
                await team.update('name')
            } catch (e) {
                this.$snack.netWorkError()
                this.renamingTeam = false
            }
        },

        duplicateTeamName(str) {
            if (!str)
                return 'Required Value'
            if (this.teams.filter(team => team !== this.selectedTeam && team.name.toLowerCase() === (str || '').toLowerCase()).length)
                return 'Team name already exists'
            return true
        },

        async deleteTeam() {
            this.deletingTeam = true
            try {
                this.deletingTeam = true
                const res = await this.selectedTeam.delete()
                this.showConfirmDelete = false
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError()
            } finally {
                this.deletingTeam = false;
            }
        },

        async addEmployeesToTeam() {
            try {
                this.addingEmployees = true
                const res = await this.$newReq('POST', `teams/addEmployees`, {
                    teamId: this.selectedTeam._id,
                    employeeIds: this.selectedAddEmployees
                })
                this.showAddEmployees = false;
            } catch (e) {
                this.$snack.netWorkError()
            }
        },

        test() {

        }
    },
    computed: {
        ...mapGetters(['employeesByTeam', 'users', "usersRef", "employees", "teams"]),
        employeesByTeamSorted() {
            return [...(this.employeesByTeam[this.selectedTeam._id] || [])]
                    .filter((emp) => !this.employeeFilterStr ? true : JSON.stringify(emp).toLowerCase().includes((this.employeeFilterStr || '').toLowerCase()))
                    .sort(nameSort)
        },

        availableEmployees() {
            const addedEmps = (this.employeesByTeam[this.selectedTeam._id] || [])
                .map(obj => obj._id);

            let availableEmps = this.employees
                .filter(emp => !emp.disabled && !emp.teamId && !addedEmps.includes(emp._id))
                // .sort((a,b) => a.name > b.name ? 1 : -1);

            return availableEmps
        }
    },
}
</script>

<style scoped>

</style>